import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss";
import { Images } from '../../assets';
import ProfileDetails from './components/ProfileDetails';
import ProfileCredentialManager from './components/ProfileCredentialManager';
import Exported from '../../service/endpoints';
import request from '../../service';
import { Toast } from '../../service/toast';

const UserProfile = () => {
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const getUserProfile = async () => {
        await request({
            url: Exported.Endpoints.adminProfile,
            method: Exported.APIMethods.GET,
        }).then((res) => {
            console.log(res)
            if (res?.data?.status) {
                const response = res?.data?.data
                setName(response?.name)
                setEmail(response?.email)
            }
        }).catch((err) => {
            console.log(err)
            Toast({
                type: 'error',
                message: 'User profile not found!..'
            })
        })
    }

    useEffect(() => {
        getUserProfile()
    }, [])
    return (
        <div className={`${classes.userProfileWrapper}`}>
            <div className={`${classes.userProfileBanner}`}>
                <img src={Images?.profileBanner} alt={'Profile Banner'} />
            </div>
            <div className={`${classes.profileContainer}`}>
                <div className={`${classes.detailContainer} ${classes.profileDetails}`}>
                    <ProfileDetails name={name} email={email} letter={name?.charAt(0)} />
                </div>
                <div className={`${classes.detailContainer} ${classes.profileCredentials}`}>
                    <ProfileCredentialManager />
                </div>
            </div>
        </div>
    )
}

export default UserProfile